/**
 * Cockpit-wide constants that are NOT user-configurable feature flags.
 * These are fixed values baked into the client build.
 */
export const INTERNAL_COCKPIT_SETTINGS = {
  /** Max timeframe (days) allowed for date-range queries. */
  maxTimeframe: 466,
  /**
   * The pre-configured "InvestLab" portfolio used when the user has no
   * custom portfolio selected on the homepage.
   */
  portfolioInvestLab: {
    name: 'InvestLab',
    content: [
      'stock_index:dax_30',
      'stock_index:ftse_250',
      'stock_index:nikkei_225',
      'stock_index:s_p_500',
      'stock_index:cac_40',
      'stock_index:smi',
      'stock_index:djia',
      'stock_index:hsi',
      'stock_index:stoxx_europe_600',
    ],
  },
};
